import { render } from "./Campaign20230410_1.vue?vue&type=template&id=52dd2403&scoped=true"
import script from "./Campaign20230410_1.vue?vue&type=script&lang=js"
export * from "./Campaign20230410_1.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-52dd2403"

export default script